import { ACTIONS } from "./../constants"


const initialState = { 
  pfis: [], 
  pfi: {}, 
  totalSize: 0,
  isFetching: false, 
  isLoading: false,
  hasMore: true, 
  success: {
    isCreated: false,
    isUpdated: false,
    isDeleted: false
  },
  error: null
}


export default (state = initialState , action) => {
  const { payload, type } = action
  switch (type) {

    case ACTIONS.CLEAR_PFI : {
      return { ...state, success: initialState.success, error: null, isFetching: false, isLoading: false , pfis:[],pfi:{}}
    }

    case ACTIONS.FETCH_PFIS_INIT : {
      return { ...state, isFetching: true, error: null }
    }
    case ACTIONS.FETCH_PFIS_SUCCEDED : {
      const { count, results } = payload
      return { ...state, totalSize: count, pfis: results, isFetching: false, error: null }
    }
    case ACTIONS.FETCH_PFIS_FAILED : {
      return { ...state, isFetching: false, error: payload }
    }

    case ACTIONS.CREATE_PFI_INIT : {
      return { ...state, isLoading: true, error: null, success: initialState.success }
    }
    case ACTIONS.CREATE_PFI_SUCCEDED : {
      return { ...state, success: { ...state.success, isCreated: true }, isLoading: false, error: null }
    }
    case ACTIONS.CREATE_PFI_FAILED : {
      return { ...state, error: payload, isLoading: false, success: false }
    }

    case ACTIONS.EDIT_PFI_INIT : {      
      return { ...state, isLoading: true, error: null, success: initialState.success }
    }
    case ACTIONS.EDIT_PFI_SUCCEDED : {
      return { ...state, success: { ...state.success, isUpdated: true }, isLoading: false, error: null,pfi: payload }
    }
    case ACTIONS.EDIT_PFI_FAILED : {
      return { ...state, error: payload, isLoading: false, success: false }
    }
 
    case ACTIONS.FETCH_PFI_INIT : {
      return { ...state, isLoading: true, pfi: null, error: null }
    }
    case ACTIONS.FETCH_PFI_SUCCEDED : {
     
      

      return { ...state, pfi: payload, isLoading: false, error: null }
    }
    case ACTIONS.FETCH_PFI_FAILED : {
      return { ...state, isLoading: false, error: payload }
    }

    case ACTIONS.DELETE_PFI_INIT : {
      return { ...state, isLoading: true, success: initialState.success, error: null }
    }
    case ACTIONS.DELETE_PFI_SUCCEDED : {
      return { ...state, success: { ...state.success, isDeleted: true }, isLoading: false, error: null }
    }
    case ACTIONS.DELETE_PFI_FAILED : {
      return { ...state, isLoading: false, error: payload }
    }

    default: {
      return state
    }
  }
}
